import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "options", "useGap"];
import { c as _c } from "react-compiler-runtime";
import { isValidElement, cloneElement, useContext } from 'react';
import I18n from 'I18n';
// @ts-expect-error untyped JS module
import { getPassThroughProps, interpolateToArray } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_OPTIONS = {};
// @ts-expect-error untyped
const getEscapedParam = (param, key, index) => {
  if (! /*#__PURE__*/isValidElement(key)) {
    return /*#__PURE__*/_jsx("span", {
      // @ts-expect-error formatParam i is untyped
      dangerouslySetInnerHTML: {
        __html: I18n.formatParam(param, key)
      }
    }, `${param}-${index}`);
  }
  return /*#__PURE__*/cloneElement(key, {
    key: `${param}-${index}`,
    // @ts-expect-error Property 'ref' does not exist on type 'ReactElement<unknown, string | JSXElementConstructor<any>>
    ref: key.ref
  });
};
function FormattedReactMessage(t0) {
  const $ = _c(6);
  const {
      message,
      options: t1,
      useGap: t2
    } = t0,
    rest = _objectWithoutPropertiesLoose(t0, _excluded);
  const options = t1 === undefined ? DEFAULT_OPTIONS : t1;
  const useGap = t2 === undefined ? false : t2;
  useContext(I18nHMRContext);
  const props = getPassThroughProps(Object.assign({
    message,
    options,
    useGap
  }, rest));
  let t3;
  if ($[0] !== message || $[1] !== options) {
    t3 = interpolateToArray(message, options, getEscapedParam);
    $[0] = message;
    $[1] = options;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formattedMessage = t3;
  let t4;
  if ($[3] !== formattedMessage || $[4] !== props) {
    t4 = /*#__PURE__*/_jsx("span", Object.assign({}, props, {
      children: formattedMessage
    }));
    $[3] = formattedMessage;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
FormattedReactMessage.displayName = 'FormattedReactMessage';
FormattedReactMessage.isI18nElement = true;
export default FormattedReactMessage;